export default "__VITE_ASSET__8e554b13__"